module.exports = __webpack_public_path__ + "static/media/manufacture.3e1823f7.jpg";